export class AppFormSection extends HTMLElement {
  static get observedAttributes() {
    return ["title", "description"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const title = this.getAttribute("title") || "";
    const description = this.getAttribute("description") || "";
    const content = this.innerHTML;

    // Check if inner structure already rendered
    const existingSection = this.querySelector(".form-section-container");
    if (existingSection) return;

    this.innerHTML = `
      <div class="form-section-container" style="display: flex; flex-direction: column; gap: 16px; padding: 20px; background: var(--color-surface-primary); border: 1px solid var(--color-border-default); border-radius: var(--radius-sm); margin-bottom: 20px;">
        ${title ? `
          <div style="border-bottom: 1px solid var(--color-border-subtle); padding-bottom: 8px;">
            <h3 class="text-subsection-title">${title}</h3>
            ${description ? `<p class="text-caption" style="margin-top: 2px;">${description}</p>` : ""}
          </div>
        ` : ""}
        <div class="form-section-content">
          ${content}
        </div>
      </div>
    `;
  }
}

if (!customElements.get("app-form-section")) {
  if (!customElements.get("app-form-section")) {
    customElements.define("app-form-section", AppFormSection);
  }
}
